<template>
  <v-dialog v-model="dialog" scrollable width="700">
    <v-card>
      <v-toolbar color="primary" dense class="elevation-0" dark>
        <v-toolbar-title>{{ type === 'update' ? 'SỬA XE TUYẾN' : 'THÊM TUYẾN MỚI' }}</v-toolbar-title>
        <v-spacer />
        <v-btn icon dark @click="cancel">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-form ref="form" class="pt-6">
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="name"
                label="Tên xe tuyến"
                placeholder="Nhập tên tuyến"
                hide-details="auto"
                outlined
                dense
                class="required"
                :rules="[$rules.required]"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <AutocompleteTeacherCard
                v-model="driver"
                return-object
                class="required"
                item-text="title"
                item-value="id"
                label="Giáo viên phụ trách"
                hide-details="auto"
                required
                dense
                outlined
                :rules="[$rules.required]"
              />
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="maxStudent"
                label="Số học sinh tối đa"
                hide-details="auto"
                outlined
                dense
                class="required"
                :rules="[$rules.required]"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-select
                v-model="status"
                :items="busStatus"
                clear-icon="mdi-close"
                item-text="title"
                item-value="status"
                label="Chọn trạng thái"
                hide-details="auto"
                outlined
                dense
                clearable
                class="required"
                :rules="[$rules.required]"
              />
            </v-col>
            <v-col cols="12">
              <v-textarea v-model="notes" label="Ghi chú" hide-details="auto" outlined></v-textarea>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-divider />
      <v-card-actions class="pa-4">
        <v-btn outlined @click="cancel">HUỶ</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="save">LƯU</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import AutocompleteTeacherCard from '@/components/basic/input/AutocompleteTeacherCard.vue'
import { mapActions, mapState } from 'vuex'
import { textHelpers } from '@/helpers/TextHelper.js'
import { get } from 'lodash'

export default {
  components: {
    AutocompleteTeacherCard
  },
  props: {
    state: Boolean
  },
  data() {
    return {
      dialog: false,
      id: null,
      type: '',
      name: '',
      status: 'active',
      driver: '',
      maxStudent: 20,
      notes: ''
    }
  },
  computed: {
    ...mapState('constant', ['busStatus']),
    ...mapState('staff', ['staffs']),
    ...mapState('bus', ['busesData'])
  },
  methods: {
    ...mapActions({
      create: 'bus/create',
      requestPageSetting: 'bus/requestPageSetting',
      searchBuses: 'bus/searchBuses',
      update: 'bus/update'
    }),
    get,
    openDialog(type, item) {
      if (type === 'update') {
        this.name = item.name
        this.driver = get(item, 'driver._id')
        this.maxStudent = item.data && item.data.maxStudent
        this.status = item.status
        this.notes = item.notes
        this.id = item.id
      }
      this.type = type
      this.dialog = true
    },
    cancel() {
      this.dialog = false
      this.reset()
      this.$refs.form.resetValidation()
    },
    async save() {
      if (!this.$refs.form.validate()) return
      try {
        this.$loading.active = true
        const data = {
          name: textHelpers.removeSpaces(this.name),
          driver: this.driver.id,
          notes: this.notes,
          status: this.status,
          data: {
            maxStudent: this.maxStudent
          }
        }
        if (this.type === 'update') {
          await this.update({ id: this.id, ...data })
        } else {
          await this.create(data)
        }
        this.reset()
        this.$refs.form.resetValidation()
        await this.refresh({})
        this.$alert.success('Thành công')
        this.dialog = false
      } catch (error) {
        this.$alert.error(error)
      } finally {
        this.$loading.active = false
      }
    },

    reset() {
      this.status = 'active'
      this.name = null
      this.driver = null
      this.maxStudent = 20
      this.notes = null
      this.type = ''
      this.id = null
    },
    async refresh(query) {
      query = query || {}
      this.searchBuses({
        ...query
      })
    }
  },
  watch: {
    state(state) {
      this.dialog = true
    }
  }
}
</script>
